// extracted by mini-css-extract-plugin
export default {"card":"hY-z","carouselContainer":"iY-z","carouselContent":"jY-z"};